module.exports = __webpack_public_path__ + "img/princess-bubblegum.35d67941.png";